import React from 'react';

import { NavigationItemLink, NavigationSubItem } from '../../index';

export const NavigationItem = ({
    navItems,
    onItemClick = () => { },
    isSelectedLink = () => { },
    isActiveSubMenu = () => { },
    toggleMainMenu = () => { }
}) => {

    return <ul>
        {(navItems && navItems.length > 0) && navItems.map((navItem, index) => {
            const subMenuItem = navItem.subMenuItems;

            return <li
                className={`bsw-navigation__item ${isActiveSubMenu(`${index}`) ? 'active' : ''}`}
                data-key={index}
                key={index}
                >
                    <NavigationItemLink
                        index={index}
                        navItem={navItem}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        onItemClick={(...props) => { onItemClick(...props); }}
                        toggleMainMenu={toggleMainMenu}
                    />
                    {(isActiveSubMenu(`${index}`) && subMenuItem !== null) && 
                        <NavigationSubItem
                        label={subMenuItem.menuLabel}
                        subNavItems={subMenuItem.menuItems}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        onDismiss={(...props) => { onItemClick(...props) }}
                        onSubItemClick={(...props) => { onItemClick(props[0], props[1], props[2]); }}
                        toggleMainMenu={toggleMainMenu}
                        />
                    }
                </li>
            })
        }
    </ul>
}
